// Module
var code = "<template> <div dt-grid-container> <dt-card> <span slot=\"title\">Permission denied</span> You do not have permission to view the requested page. </dt-card> </div> </template>";
// Exports
export default code;